function convertUser(user) {
  if (user) {
    return { label: user.lastName + ", " + user.firstName, value: user };
  } else {
    return { label: "", value: "" };
  }
}

export default convertUser;
